module.exports = __webpack_public_path__ + "static/Muli-Light-9ea7b84129925c4fd62e3dfc9bae766b.ttf";